module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recordWasStopped":"Recording was interrupted","chooseOption":"Choose an option","resumeOfficeInterview":"Continue recording","overwrite":"Overwrite","save":"Save"}}')
  delete Component.options._Ctor
}
